// Central product-image URL builder (mirrors the cld-b2c ProductGrid approach).
//
// The BE (products-search) already returns images in type priority — the boxed
// packshot (`product_image_boxed_large`) first, which is a standard 2:3 portrait.
// So we request a 2:3 box: `fit=pad` then has no bars to add for packshots, and the
// grid tiles stay uniform. Where padding *is* needed (non-2:3 sources), the pad
// background follows the active theme so the bars blend into the image well
// (light gray in light mode, the dark surface in dark mode) instead of flashing white.

const CDN_BASE = "https://assets.cld.eu/cdn-cgi/image";

export const PRODUCT_FALLBACK_IMAGE =
  "https://assets.cld.be/cdn-cgi/image/width=200,quality=40/9/3/1/0/931054989870582dda8788cf81759668c311beee_Image_Coming_Soon.png";

export const useProductImage = () => {
  // Build a Cloudflare Image Resizing URL.
  //   path    raw PIM path from the API (e.g. "9/3/1/0/xxxx.jpg")
  //   width/height  request a 2:3 box for packshots (e.g. 200x300)
  //
  // The `fit=pad` letterbox is left TRANSPARENT (no `background` param, webp keeps
  // alpha). The visible pad colour therefore comes from the CSS image well, which is
  // already theme-aware (bg-gray-50 → light / dark surface). Crucially this keeps the
  // URL identical on server and client — a colorMode-dependent URL caused a hydration
  // mismatch (and a re-fetch) on every product image.
  const getImgUrl = (path, opts = {}) => {
    if (!path) return PRODUCT_FALLBACK_IMAGE;
    // Already an absolute URL (fallback image, CMS asset, ...) — leave as-is.
    if (/^https?:\/\//i.test(path)) return path;

    const { width, height, quality = 75, format = "webp", fit = "pad" } = opts;

    const parts = [`format=${format}`];
    if (width) parts.push(`width=${width}`);
    if (height) parts.push(`height=${height}`);
    parts.push(`quality=${quality}`, `fit=${fit}`);

    return `${CDN_BASE}/${parts.join(",")}/${path}`;
  };

  return { getImgUrl, PRODUCT_FALLBACK_IMAGE };
};
